import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'actionClass',
})
export class ActionClassPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'primary':
        return 'border-none bg-primary-500 text-white';
      case 'danger':
        return 'border-none text-destructive-500 bg-destructive-50';
      case 'natural':
        return 'border-none text-neutral-700 bg-neutral-100';
      case 'secondary':
        return 'border-none text-primary-500 bg-primary-50';
      default:
        return 'text-neutral-700 bg-white border border-neutral-300';
    }
  }
}
